import { OPERATOR, type BinaryOperator } from 'common/components/FilterBar/SoqlFilter';

type TextFilterOperators = Partial<Record<OPERATOR, string>>;

const textFilterOperators: TextFilterOperators = {
  [OPERATOR.EQUALS]: '',
  [OPERATOR.NOT_EQUAL]: 'Excluded',
  [OPERATOR.STARTS_WITH]: 'Starts with',
  [OPERATOR.CONTAINS]: 'Contains',
  [OPERATOR.DOES_NOT_CONTAIN]: 'Does not contain',
};

export const generateTextFilterDetails = (filter: BinaryOperator) => {
  let operator = '';

  if (filter.joinOn && filter.joinOn === 'AND') {
    operator = textFilterOperators[OPERATOR.NOT_EQUAL] || '';
  } else if (filter.joinOn && filter.joinOn === 'OR') {
    operator = textFilterOperators[OPERATOR.EQUALS] || '';
  } else {
    operator = textFilterOperators[filter.arguments[0].operator] || '';
  }

  const filterValues = filter.arguments
    .map((argument) => {
      if (argument.operator === OPERATOR.NULL || argument.operator === OPERATOR.NOT_NULL) {
        return '(No Value)';
      }
      return argument.operand;
    })
    .join(', ');

  const columnName = filter.columns[0].displayName || filter.columns[0].fieldName || '';
  return {
    columnName,
    predicate: `${operator} ${filterValues}`,
  };
};
